<template>
  <div v-if="!dismissed" class="v3-widget v3-coach" role="status" v-testid="testid">
    <span class="ms">{{ icon }}</span>
    <span class="v3-coach-text">{{ message }}</span>
    <button class="v3-coach-x" type="button" aria-label="Dismiss" v-testid="testid + '-dismiss'" @click="dismissed = true"><span class="ms">close</span></button>
  </div>
</template>

<script>
// New-portal (v3) CoachToast — a dismissible coaching tip (prototype
// V3CoachToast), rendered inline. Pure presentation. Sibling:
// rm-portal-beta CoachToastWidget.vue.
export default {
  name: "cLandingV3CoachToast",
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  data() {
    return { dismissed: false };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3CoachToast";
    },
    message() {
      return this.definition.message || "Invitations also arrive by email and take you straight into the evaluation.";
    },
    icon() {
      return this.definition.icon || "mail";
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
